const styles = {
  arrowLeft: {
    rotate: '90deg',
  },
};

export default styles;
